import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session-data", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(res.data);
        const pendingJoin = localStorage.getItem("pending_join");
        if (pendingJoin) {
          navigate(`/join/${pendingJoin}`, { replace: true });
          return;
        }
        navigate("/", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
